export const rezDeChausses = [
      {
            id: 1,
            img: "/pictures/descriptif/salon/rdc_chaumiere5.jpg",
            alt: "Salon",
      },

      {
            id: 2,
            img: "/pictures/descriptif/sallemanger/rdc_salon2.jpg",
            alt: "Salle à manger",
      },

      {
            id: 3,
            img: "/pictures/descriptif/cuisine/rdc_cuisine1.jpg",
            alt: "Cuisine",
      },

      {
            id: 4,
            img: "/pictures/descriptif/chambrerdc/rdc_chambre_1.jpg",
            alt: "Chambre",
      },

      {
            id: 5,
            img: "/pictures/descriptif/sdb/rdc_douche1.jpg",
            alt: "Douche",
      },
];

export const etages = [
      {
            id: 1,
            img: "/pictures/descriptif/chambre1/etage6.jpg",
            alt: "Salle à manger",
      },

      {
            id: 2,
            img: "/pictures/descriptif/chambre2/chambre_2_lit_etage_2.jpg",
            alt: "Salle à manger",
      },

      {
            id: 3,
            img: "/pictures/descriptif/chambre1/etage7.jpg",
            alt: "Salle à manger",
      },
];

export const jardins = [
      {
            id: 1,
            img: "/pictures/descriptif/jardin/jardin_vue_ensemble.jpg",
            alt: "Jardin vue d'ensemble",
      },

      {
            id: 3,
            img: "/pictures/descriptif/jardin/jardin_terrasse.jpg",
            alt: "jardin_terrasse.jpg",
      },

      {
            id: 4,
            img: "/pictures/descriptif/jardin/chaise_jardin_2.jpg",
            alt: "Chaise jardin",
      },

      {
            id: 6,
            img: "/pictures/descriptif/jardin/jaccuzzi.jpg",
            alt: "Jaccuzzi",
      },

      {
            id: 7,
            img: "/pictures/descriptif/jardin/jeux_enfants.jpg",
            alt: "Jeux pour enfants",
      },

      {
            id: 2,
            img: "/pictures/descriptif/jardin/jardin_vue_ensemble_2.jpg",
            alt: "Jardin vue d'ensemble",
      },

      {
            id: 5,
            img: "/pictures/descriptif/jardin/chaise_jardin.jpg",
            alt: "Chaise jardin",
      },

      {
            id: 8,
            img: "/pictures/descriptif/jardin/table_festin_jardin.jpg",
            alt: "Table festin jardin.jpg",
      },
];